// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__U0CSX","img":"Avatar_img__p94Tc","fallback":"Avatar_fallback__I4KZK","clickable":"Avatar_clickable__gft4V"};